import React, { Suspense, useEffect, useState } from 'react'
import camelize from 'camelize'

import { useActiveMembershipContext } from '../../ActiveMembershipStore'
import { useSubscribeContext } from 'context'
import { useAlert } from 'hooks'
import { Spinner } from 'ui/bend'

const CancellationSurvey = React.lazy(() =>
  import(
    /* webpackChunkName: 'cancellation-survey' */ 'components_v1/membership/cancellationSurvey/CancellationSurvey'
  )
)

const CancelMembership = (props) => {
  const [surveyQuestions, setSurveyQuestions] = useState([])
  const { actions } = useSubscribeContext()
  const { refreshMembershipInfo } = useActiveMembershipContext()
  const setAlert = useAlert()

  useEffect(() => {
    const url =
      'https://alomoves.s3.amazonaws.com/manual_uploads/shared/surveys/cancellation/cancellation_survey_questions_v3.json'

    const getSurveyQuestions = async () => {
      // We use fetch here because the URL is stored as a json blob on s3.
      fetch(url)
        .then((res) => res.json())
        .then((res) => setSurveyQuestions(camelize(res)))
    }

    getSurveyQuestions()
  }, [])

  const handleClose = (condition) => {
    switch (condition) {
      case 'offerAccepted': {
        setAlert({
          message: 'We have added additional time to your account!'
        })
        break
      }
      case 'cancelled': {
        setAlert({
          message: 'We have cancelled your account.'
        })
        break
      }
      default: {
        break
      }
    }
    actions.membership.refreshPlans()
    refreshMembershipInfo()
  }

  // TODO: remove-candy-check -- Refactor CancellationSurvey into V2 and split business and display logic.
  return (
    <Suspense fallback={<Spinner />}>
      <CancellationSurvey
        questions={surveyQuestions}
        closeCallback={handleClose}
      />
    </Suspense>
  )
}

CancelMembership.propTypes = {}

export default CancelMembership
